import './App.css'
import Card from './components/Card'

function App() {
  return (
    <>
      <div className='custom-bg  h-48 w-full bg-hsl'></div>
      <div className='mt-16'>
        <Card />
      </div>
    </>
  )
}

export default App
